import { useLocation, Navigate, Outlet } from "react-router-dom";

import React from "react";

import { canOpenScreen } from "../../helpers/companyScreens";

// `screen`: tela da Visão Empresa (src/helpers/companyScreens.js) que o EMP abre por permissão
const Auth = ({ allowedRoles = [], screen }) => {
  const auth = JSON.parse(localStorage.getItem("user_ow"));
  const location = useLocation();

  if (!auth?.name) {
    return <Navigate to="/sign-up" state={{ from: location }} replace />;
  }

  const roleOk = allowedRoles.length > 0 && allowedRoles.includes(auth.role);
  const allowed = roleOk || (!!screen && canOpenScreen(screen, auth));

  return allowed ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default Auth;
